const Todos = () => {
    return <h1>De facut</h1>
}

export default Todos